<template>
    <div>
      <a-drawer
          :title='title'
          :visible="visible"
          v-bind="drawerConfig"
          :body-style="{ paddingBottom: '80px' }"
          @close="onClose"
      >
      <a-form-model ref="form" :model="form" v-bind="layout">
        <a-form-model-item
            ref="title"
            label="消息标题"
            prop="title"
            :rules="{ required: true, message: '请输入消息标题', trigger: 'blur', }"
        >
          <a-input :maxLength=50  v-model="form.title"  />
        </a-form-model-item>
        <a-form-model-item
            ref="status"
            label="状态"
            prop="status"
        >
          <a-radio-group v-model="form.status"  >
            <a-radio :value="1"> 发布 </a-radio>
            <a-radio :value="2"> 草稿 </a-radio>
          </a-radio-group>
        </a-form-model-item>

     <a-form-model-item
         ref="release_time"
         label="发布时间"
         prop="release_time"
         :help="formErr.release_time"
         :validateStatus='!formErr.release_time||formErr.release_time==""?"":"error"'
         :rules="{ required: true, message: '请选择发布时间', trigger: 'blur', }"
 > <a-date-picker  format="YYYY-MM-DD HH:mm:ss" show-time  v-model="form.release_time"/>

        </a-form-model-item>
        <draggable v-model="form.menu"   group="people" :options="{animation:60,handle:'.drag'}">
          <transition-group>
            <div class="item flex" v-for="(item , index) in form.menu" :key="item.key"  style="padding-left:72px" >
              <img src="../../../assets/drag.png" alt="" class="drag">
              <div class="right">
                <a-form-model-item   label="菜单" :prop="'menu.' + index + '.m_admin_menu_id'"  :rules="{ required: true, message: '请选择菜单', trigger: 'blur', }"  >
                  <a-cascader placeholder=" " :fieldNames="fieldNames" :options="options"  v-model="item.m_admin_menu_id" />
                </a-form-model-item>
                <a-form-model-item  label="提示标题" :prop="'menu.' + index + '.title'"   :rules="{ required: true, message: '请输入提示标题', trigger: 'blur', }">
                  <a-input :maxLength=50 v-model="item.title"  />
                </a-form-model-item>
                <a-form-model-item  label="提示内容"  :prop="'menu.' + index + '.content'" :rules="{ required: true, message: '请输入提示内容', trigger: 'blur', }">
                  <a-input :maxLength=200 v-model="item.content" type="textarea"  />
                </a-form-model-item>
              </div>
              <a-icon
                  v-if="form.menu.length > 1"
                  class="dynamic-delete-button"
                  type="minus-circle-o"
                  :disabled="form.menu.length === 1"
                  @click="removeDomain(item)"
              />
            </div>
          </transition-group>
        </draggable>
        <p><a-button type="primary" @click="addDomain()">添加提示</a-button></p>
        <div>
          <a-button type="primary" @click="submitForm" :style="{ marginRight: '8px' }">
            确定
          </a-button>
          <a-button @click="onClose">
            取消
          </a-button>
        </div>

      </a-form-model>


      </a-drawer>
    </div>

</template>

<script>
    import {submitForm,drawerConfig} from "../../../utils/utils"
    import API from "./api";
    import draggable from 'vuedraggable'
    import moment from 'moment';
    export default {
        name: 'add',
      props: ["visible","title","editId"],
        data() {
            return {
              options:[],
              fieldNames: {label: 'name', value: 'id', children: 'children'},
              drawerConfig,
              layout: {
                labelCol: {span: 6},
                wrapperCol: {span: 14},
              },
              form:{
                title:"",
                status:1,
                release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                menu:[{m_admin_menu_id:[],title:"",content:"", key:Date.now()}],
          },
              formErr:{
                title:"",
                status:"",
                release_time:'',
                menu:[{m_admin_menu_id:"",title:"",content:""}],
              },
              dynamicValidateForm: {
                domains: [{
                  title: "",
                  alt: "",
                  href: "",
                  key: Date.now(),
                  fileList:[],
                }],
              },
            }
        },
      watch:{
        editId:function (a, b)  {
          if (a != "") {
            let _self=this
            API.prompt.GET_FORM_DATA({id:a}).then(res => {
              _self.$nextTick().then(function () {
                console.log( "_self.options",_self.options)
                let val = res.data.data.info
                val.menu.map((item,index)=>{
                  item.key = Date.now() + Math.random() + index
                  let menuVal=[...item.arrparentid].map(Number)
                  item.m_admin_menu_id=menuVal
                  delete item.arrparentid;
                })
                console.log( _self.form)
                _self.form.menu=val.menu
                _self.form.release_time=moment(val.release_time).format('YYYY-MM-DD HH:mm:ss')
                _self.form.id = a
                _self.form.title=val.title
                _self.form.status=val.status*1
              })


            })
          } else {
            this.form.id = ''
            this.form.release_time=moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
          }
        }
      },
      components: {
        draggable
      },
        computed: {

        },
        methods: {
          onClose() {
            this.$emit("changVisible", false);

            this.form={
              title:"",
              status:1,
              release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
              menu:[{m_admin_menu_id:[],title:"",content:"", key:Date.now()} ],
            }
            this.formErr={
              title:"",
              status:"",
              release_time:"",
              menu:'',
            }
          },
          submitForm(formName) {
            let _this=this
            this.$refs['form'].validate(valid => {
              if (valid) {
                // let domainsData=JSON.parse(JSON.stringify(this.dynamicValidateForm.domains))
                console.log("form",this.form)
                this.form.release_time!=""&&this.form.release_time!=null?this.form.release_time=moment(this.form.release_time).format('YYYY-MM-DD HH:mm:ss'): this.form.release_time=null

                submitForm(this.form.id?API.prompt.SUBMIT_EDIT:API.prompt.SUBMIT_ADD , _this.form).then(res => {
                  if (res == true) {
                    this.onClose()
                  } else {
                    res.map((item, index) => {
                      this.formErr[item.field] = item.msg
                    })
                  }
                })
              } else {
                console.log('error submit!!');
                return false;
              }
            });
          },

          removeDomain(item) {
            let index = this.form.menu.indexOf(item);
            if (index !== -1) {
              this.form.menu.splice(index, 1);
            }
          },
          addDomain() {
            this.form.menu.push({
              m_admin_menu_id:[],title:"",content:"",
              key: Date.now(),
            });
          },
          getList() {
            API.prompt.GET_FORM_LIST().then(res => {
              this.options = res.data.data.menu

            })
          },

        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
.drag{position: absolute;left:20px;top:100px;display: inline-block;width: 10px;cursor: pointer}
.item.flex{margin-bottom: 30px;position: relative;border: 1px dashed #999;padding:  20px;box-sizing: border-box;border-radius: 12px;width:90%;background-color: #fff}
.item.flex .left{width: 20%;margin-left: 5%}
.item.flex .right{width:75%}
.dynamic-delete-button{position: absolute;right: -30px}
.sortable-chosen{background-color: #fff!important;opacity: 1!important;z-index: 9999999999}
.sortable-ghost{background-color: #fff!important;opacity: 1!important;}
</style>
